import { render } from "./main.vue?vue&type=template&id=7bb3002e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "@/styles/striNew.css?vue&type=style&index=0&lang=css"
import "./main.vue?vue&type=style&index=1&id=7bb3002e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb3002e"]])

export default __exports__